import { render } from "./view-competence-comment.vue?vue&type=template&id=cf655ae0&scoped=true"
import script from "./view-competence-comment.vue?vue&type=script&lang=js"
export * from "./view-competence-comment.vue?vue&type=script&lang=js"

import "./view-competence-comment.vue?vue&type=style&index=0&id=cf655ae0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf655ae0"],['__file',"src/components/applications/wagesetting/update/view-competence-comment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf655ae0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf655ae0', __exports__)) {
    api.reload('cf655ae0', __exports__)
  }
  
  module.hot.accept("./view-competence-comment.vue?vue&type=template&id=cf655ae0&scoped=true", () => {
    api.rerender('cf655ae0', render)
  })

}


export default __exports__